import axios from 'axios';
import router from '../Router/index';

export default {
  namespaced: true,

  state: {
    authenticated: false,
    user: null,
    errors: null,
    blockError: false,
    errorCount: 0,
    errorTime: 0,
    blockTime: '0:00',
    currentTime: '-',
    session_time_list: [
      {
        id: 10,
        text: '10 דקות'
      },
      {
        id: 60,
        text: 'שעה'
      },
      {
        id: 720,
        text: 'חצי יום'
      },
      {
        id: 1440,
        text: 'יום 1'
      },
      {
        id: 2880,
        text: '2 ימים'
      },
      {
        id: 7200,
        text: '5 ימים'
      },
      {
        id: 10080,
        text: '7 ימים'
      },
      {
        id: 20160,
        text: 'שבועיים'
      },
      {
        id: 40320,
        text: 'חודש'
      }
    ],
    loginForm: []
  },

  getters: {
    authenticated(state) {
      return state.authenticated;
    },

    user(state) {
      return state.user;
    },
    errorsCount(state) {
      return state.errorCount;
    },
    errorTime(state) {
      return state.errorTime;
    },
    blockTime(state) {
      return state.blockTime;
    },
    getBlockError(state) {
      return state.blockError;
    },
    errors(state) {
      return state.errors;
    },
    session_time_list(state) {
      return state.session_time_list;
    }
  },

  mutations: {
    SET_CURRENT_TIME(state, value) {
      state.currentTime = value;
    },
    SET_ERROR_TIME_DEC(state) {
      state.errorTime -= 1;
    },
    SET_BLOCK_TIME_DEC(state) {
      const timer2 = state.blockTime;
      const timer = timer2.split(':');
      let minutes = parseInt(timer[0], 10);
      let seconds = parseInt(timer[1], 10);
      --seconds;
      if (minutes > 0) {
        minutes = seconds < 0 ? --minutes : minutes;
      } else {
        minutes = 0;
      }
      seconds = seconds < 0 ? 59 : seconds;
      seconds = seconds < 10 ? '0' + seconds : seconds;
      state.blockTime = minutes + ':' + seconds;
      if (minutes === 0 && seconds === '00') {
        localStorage.setItem('time', 0);
        localStorage.setItem('nowTime', 0);
      } else {
        localStorage.setItem('time', state.blockTime);
        localStorage.setItem('nowTime', new Date());
      }
    },
    SET_BLOCK_ERROR(state, value) {
      state.blockError = value;
    },
    SET_ERROR_TIME(state) {
      state.errorTime = 60;
    },
    SET_BLOCK_TIME(state, time = '5:00') {
      state.blockTime = time;
    },

    SET_AUTHENTICATED(state, value) {
      state.authenticated = value;
    },

    SET_USER(state, value) {
      state.user = value;
    },
    SET_ERRORS_COUNT(state, value) {
      state.errorCount = value;
    },
    SET_LOGIN_FORM(state, value) {
      state.loginForm = value;
    },
    SET_ERRORS(state, value) {
      if (value) {
        state.errorCount += 1;
      } else {
        state.errorCount = 0;
      }
      state.errors = value;
    }
  },
  actions: {
    SET_LOGIN_FORM({ commit }, value) {
      commit('SET_LOGIN_FORM', value);
    },
    async signIn({ dispatch, commit, state }) {
      await axios
        .get('/sanctum/csrf-cookie')
        .then
        // res => console.log(res)
        ();
      await axios
        .post('/login', state.loginForm)
        .then(res => {
          commit('SET_ERRORS', null);
          router.replace({
            name: 'Confirm',
            query: { next: router.currentRoute.query.next }
          });
        })
        .catch(err => {
          // console.log('asdasd');

          if (err.response.status === 429) {
            console.log(err.response.status);
            commit('SET_ERROR_TIME');
          } else {
            commit('SET_ERRORS', err.response.data.errors);
            // commit('SET_BLOCK_TIME','0:00');
          }
        });

      // return dispatch('me')
    },
    async confirmAuth({ dispatch, commit, state }, credentials) {
      await axios
        .post('/confirm-auth', credentials)
        .then(res => {
          commit('SET_ERRORS', null);
          dispatch('auth_me');
        })
        .catch(reason => {
          if (reason.response.status === 429) {
            commit('SET_ERRORS_COUNT', 9);
            commit('SET_BLOCK_ERROR', true);
            commit('SET_BLOCK_TIME', '5:00');
          } else {
            commit('SET_ERRORS', reason.response.data.errors);
          }
        });

      // return dispatch('me');
    },
    async logOut({ commit }) {
      commit('SET_AUTHENTICATED', false);
      commit('SET_USER', {});
      await axios.post('/logout');
    },
    async signOut({ dispatch }) {
      await axios.post('/logout');
      dispatch('abilities/update', {}, { root: true });

      return dispatch('me');
    },
    auth_me({ commit, dispatch }) {
      // return axios.get('/sanctum/csrf-cookie').then( res => {
      return axios
        .get('/api/user')
        .then(response => {
          commit('SET_AUTHENTICATED', true);
          commit('SET_USER', response.data);
          const currentRoute = router.currentRoute;
          const next = currentRoute.query.next;
          const lessonPath = sessionStorage.getItem('currentPath');
          if (response.data.is_first_login) {
            router.replace({ name: 'FirstChangePassword' });
          } else if (next) {
            router.replace(next);
          } else if (lessonPath) {
            router.replace({ path: lessonPath });
          } else {
            router.replace({ name: 'HomePage' });
          }

          dispatch('abilities/update', {}, { root: true });
          dispatch('settings/updateSettings', {}, { root: true });
        })
        .catch(() => {
          commit('SET_AUTHENTICATED', false);
          commit('SET_USER', null);
          dispatch('abilities/update', {}, { root: true });
        });
      // });
    },
    me({ commit, dispatch }) {
      // return axios.get('/sanctum/csrf-cookie').then( res => {
      return axios
        .get('/api/user')
        .then(response => {
          commit('SET_AUTHENTICATED', true);
          commit('SET_USER', response.data);
          // setTimeout(
          //   dispatch('signOut'),
          //   response.data.expiredTokenMinutes * 60
          // );
          dispatch('abilities/update', {}, { root: true });
          dispatch('settings/updateSettings', {}, { root: true });
        })
        .catch(() => {
          commit('SET_AUTHENTICATED', false);
          commit('SET_USER', null);
          dispatch('abilities/update', {}, { root: true });
        });
      // });
    },
    SET_BLOCK_TIME({ commit }, time) {
      commit('SET_BLOCK_TIME', time);
    }
  }
};
